import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Juridische structuren"
      description="Waren u, uw partner en/of uw minderjarige kinderen oprichter of derde begunstigde van juridische structuren en/of buitenlandse rechtspersonen, hybride vennootschappen of beleggingsinstelling die niet of aan lage inkomstenbelasting zijn onderworpen?"
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <RadioGroupInput
          name="legal_structures"
          items={[
            { text: 'nee', value: 'nee' },
            { text: 'ja', value: 'ja' },
          ]}
          xs={12}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
